import { render } from "./BaseResizableColumns.vue?vue&type=template&id=0c816ae9&scoped=true"
import script from "./BaseResizableColumns.vue?vue&type=script&lang=js"
export * from "./BaseResizableColumns.vue?vue&type=script&lang=js"

import "./BaseResizableColumns.vue?vue&type=style&index=0&id=0c816ae9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c816ae9"]])

export default __exports__